// extracted by mini-css-extract-plugin
module.exports = {"base":"PluseIcon_base__2mgQK","pluse":"PluseIcon_pluse__3zbcR","svg":"PluseIcon_svg__37LV-"};